// src/components/Breadcrumbs.js
import { Box, Stack, Link, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useData } from "../hooks/useData";
import { getProductByCode } from "../constants/products";
import theme from "../styles/themes/theme";

const BreadcrumbContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(1),
  "& .breadcrumb_react": {
    fontFamily: "Montserrat, Roboto, Arial, sans-serif",
    fontWeight: 500,
    fontSize: "1rem",
    lineHeight: 1.5,
    color: "#0d2445",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  "& .list_breadcrumb_react": {
    fontFamily: "Montserrat, Roboto, Arial, sans-serif",
    fontWeight: 500,
    fontSize: "1rem",
    lineHeight: 1.5,
    color: "#0d2445",
  },
  "& .breadcrumbs.responsive-img": {
    width: 32,
    height: 32,
    margin: theme.spacing(0, 1),
  },
}));

const BreadcrumbsComponent = () => {
  const { mivaGlobals } = useData();
  const product = mivaGlobals?.productcode
    ? getProductByCode(mivaGlobals.productcode)
    : null;
  const breadcrumbs = product?.breadcrumbs || [];

  return (
    <BreadcrumbContainer
      className="list_breadcrumb_react"
      sx={{
        display: { xs: "none", sm: "block" },
      }}
    >
      <Box>
        <Stack
          direction="row"
          spacing={{
            xs: theme.spacing(1),
            sm: theme.spacing(2),
          }}
          alignItems="center"
        >
          <Link
            href="https://www.alphabetsigns.com"
            className="breadcrumb_react"
            underline="none"
          >
            <Typography
              className="breadcrumb_react list_breadcrumb_react"
              sx={{
                fontSize: { xs: "0.875rem", sm: "1rem", md: "1.125rem" },
              }}
            >
              Home
            </Typography>
          </Link>
          {breadcrumbs.map((crumb, index) => (
            <Stack key={crumb.href} direction="row" alignItems="center">
              <img
                style={{
                  width: "2rem",
                  height: "2rem",
                  margin: theme.spacing(0, 0.5),
                }}
                className="breadcrumbs_react responsive-img"
                alt="keyboard arrow right icon"
                src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iIzBkMjQ0NSI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTguNTkgMTYuNTlMMTMuMTcgMTIgOC41OSA3LjQxIDEwIDZsNiA2LTYgNi0xLjQxLTEuNDF6Ii8+PC9zdmc+"
              />
              <Link
                href={crumb.href}
                className="breadcrumb_react"
                underline="none"
              >
                <Typography
                  className="breadcrumb_react list_breadcrumb_react"
                  sx={{
                    fontSize: { xs: "0.875rem", sm: "1rem", md: "1.125rem" },
                  }}
                >
                  {crumb.name}
                </Typography>
              </Link>
            </Stack>
          ))}
        </Stack>
      </Box>
    </BreadcrumbContainer>
  );
};

export default BreadcrumbsComponent;
